var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrValid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 37.5998L40.1496 21.9499L36.8498 18.6501L24.4997 31.0002L19.1496 25.6501L15.8498 28.9499L24.4997 37.5998Z",
    fill: "#841D80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3332 28C51.3332 40.8867 40.8865 51.3334 27.9998 51.3334C15.1132 51.3334 4.6665 40.8867 4.6665 28C4.6665 15.1134 15.1132 4.66669 27.9998 4.66669C40.8865 4.66669 51.3332 15.1134 51.3332 28ZM46.6665 28C46.6665 38.3093 38.3092 46.6667 27.9998 46.6667C17.6905 46.6667 9.33317 38.3093 9.33317 28C9.33317 17.6907 17.6905 9.33335 27.9998 9.33335C38.3092 9.33335 46.6665 17.6907 46.6665 28Z",
    fill: "#841D80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrValid);
export default __webpack_public_path__ + "static/media/QRValid.79081de68d313e41f3ff718144c1a3fa.svg";
export { ForwardRef as ReactComponent };